import { apiSlice } from '@/api/api.slice.tsx';

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    finalizePayment: builder.mutation<void, string>({
      query: (intentId) => ({
        url: `/finalize-setup-intent/${intentId}`,
        method: 'POST',
      }),
      invalidatesTags: ['PaymentMethod'],
    }),
  }),
});

export const { useFinalizePaymentMutation } = curr;
